import _extends from "@babel/runtime-corejs3/helpers/extends";
import * as _ from "../../../util/lodash";
import React from 'react';
import { connect } from 'react-redux';
import { createComponent, PropTypes } from "../../../wayin-react";
import { positions } from "../../../enums";
import { wrapDisplayName } from 'react-recompose';
import Actions from "../form/actions";
import Selectors from "../form/selectors";

var validatable = function validatable(validators, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      validateOn = _ref.validateOn,
      hasErrorIcon = _ref.hasErrorIcon;

  return function (Component) {
    return connect(mapStateToProps, mapDispatchToProps)(createComponent({
      displayName: wrapDisplayName(Component, 'validator'),
      propTypes: {
        errorMessagePosition: PropTypes.oneOf(positions.ALL),
        fieldId: PropTypes.string.isRequired,
        formId: PropTypes.string.isRequired,
        shouldDeregisterOnUnmount: PropTypes.bool,
        validateOn: PropTypes.oneOf(['onBlur', 'onChange']),
        validateOnMount: PropTypes.bool,
        validationContext: PropTypes.object,
        hasErrorIcon: PropTypes.bool,
        shouldShowErrorState: PropTypes.bool
      },
      defaultProps: {
        errorMessagePosition: positions.TOP_LEFT,
        shouldDeregisterOnUnmount: false,
        validateOn: 'onBlur',
        validateOnMount: false,
        validationContext: undefined,
        hasErrorIcon: true,
        shouldShowErrorState: true
      },
      handlers: {
        handleChange: function handleChange(p) {
          return function (e, _ref2) {
            var value = _ref2.value,
                id = _ref2.id;
            //  validation
            p.enhancedChange(p.formId, p.fieldId, value, p.validationContext, p.validateOn === 'onChange' || !_.isEmpty(p.fieldErrors)); //  component onChange

            p.onChange && p.onChange(e, {
              value: value,
              id: id
            });
          };
        },
        handleBlur: function handleBlur(p) {
          return function (e, componentProps) {
            var value = componentProps ? componentProps.value : e.target.value;
            var id = componentProps ? componentProps.id : p.id; //  valiation

            p.enhancedChange(p.formId, p.fieldId, value, p.validationContext, p.validateOn === 'onBlur'); //  component on blur

            p.onBlur && p.onBlur(e, {
              value: value,
              id: id
            });
          };
        }
      },
      lifecycles: {
        componentDidMount: function componentDidMount() {
          var _this$props = this.props,
              formId = _this$props.formId,
              fieldId = _this$props.fieldId,
              registerField = _this$props.registerField,
              value = _this$props.value,
              validationContext = _this$props.validationContext,
              validateOnMount = _this$props.validateOnMount,
              enhancedChange = _this$props.enhancedChange;
          registerField(formId, fieldId, value, validationContext, validators); //  validation on render

          if (validateOnMount) enhancedChange(formId, fieldId, value, validationContext, validateOnMount);
        },
        componentWillUnmount: function componentWillUnmount() {
          if (this.props.shouldDeregisterOnUnmount) {
            this.props.deregisterField(this.props.formId, this.props.fieldId);
          }
        },
        componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
          var validationContextChanged = !_.isEqual(this.props.validationContext, prevProps.validationContext);

          if (validationContextChanged || !_.isEqual(this.props.value, prevProps.value)) {
            var _this$props2 = this.props,
                formId = _this$props2.formId,
                fieldId = _this$props2.fieldId,
                value = _this$props2.value,
                validationContext = _this$props2.validationContext;
            this.props.enhancedChange(formId, fieldId, value, validationContext, this.props.validateOn === 'onChange' || this.props.validateOn === "onBlur" && validationContextChanged //should validate
            );
          }
        }
      },
      refs: {},
      render: function render(p) {
        //  need a better solution on how to omit these hoc props from component
        var props = _.omit(p, ['deregisterField', 'enhancedChange', 'errorMessagePosition', 'fieldErrors', 'fieldId', 'fieldValue', 'formId', 'handleBlur', 'handleChange', 'initialValue', 'isFieldDirty', 'isFieldValid', 'registerField', 'shouldDeregisterOnUnmount', 'validateOn', 'validateOnMount', 'validationContext', 'shouldShowErrorState']);

        var hasErrors = !_.isEmpty(p.fieldErrors);
        return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
          errorMessage: hasErrors && p.shouldShowErrorState ? p.fieldErrors.join(', ') : undefined,
          onChange: p.handleChange,
          onBlur: p.handleBlur,
          errorMessagePosition: p.errorMessagePosition
        }));
      }
    }));
  };
};

export default validatable;

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    registerField: function registerField(formId, fieldId, value, validationContext, validators) {
      return dispatch(Actions.registerField(formId, fieldId, value, validationContext, validators));
    },
    deregisterField: function deregisterField(formId, fieldId) {
      return dispatch(Actions.deregisterField(formId, fieldId));
    },
    enhancedChange: function enhancedChange(formId, fieldId, value, validationContext, shouldValidate) {
      return dispatch(Actions.changeField(formId, fieldId, value, validationContext, shouldValidate));
    }
  };
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    fieldValue: Selectors.getFieldValue(state, ownProps.formId, ownProps.fieldId),
    fieldErrors: Selectors.getFieldErrors(state, ownProps.formId, ownProps.fieldId),
    isFieldValid: Selectors.isFieldValid(state, ownProps.formId, ownProps.fieldId),
    isFieldDirty: Selectors.isFieldDirty(state, ownProps.formId, ownProps.fieldId)
  };
};
//# sourceMappingURL=validatable.js.map